import { Field } from "formik";
import React, { useEffect,useState } from "react";
import axios from "axios";
import config from "../../../config/config";
const LocationSquare = (props) => {
  const token = localStorage.getItem("Token");
  const [selectedcurrency, setSelectedCurrency] = useState([]);

  useEffect(() => {
  axios
      .get(`${config.generalBaseUrl}/generals/currencycodedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res);
        setSelectedCurrency(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
    }, []);
  return (
    <>{props.showhidecomponent && 
      <div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Disable Amount Confirmation When Processing Credit Card
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="DisableAmountConfirmation"
                name="DisableAmountConfirmation"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Use Integrated EBT
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="UseIntegratedEBT"
                name="UseIntegratedEBT"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Currency Code
              </label>
              <div className="col-md-9">
                <Field
                  as="select"
                  className="form-control"
                  name="Currencycode"
                  id="Currencycode"
                    // value={selectCredit}
                    // onChange={(event) => {
                    //   handleDropdownChange(event);
                    // }}
                >
                  <option value={""}></option>
                  {selectedcurrency.map((u) => (
                    <option value={u.ID}> {u.CodeName} </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Multiplier To Get Total In Cents
              </label>
              <div className="col-md-9">
                <Field
                  type="number"
                  className="form-control"
                  // onChange={handleChange}
                  id="Multipliercents"
                  name="Multipliercents"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </>
  );
};
export default LocationSquare;
